import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, Users, Map } from "lucide-react";

export const SCENARIO_GUIDE_URL = "https://toolkit.managemeantexcellence.com";

const TOOLKITS = [
  { key: "part_1", short: "The Role", to: "/app/part/part_1", icon: Briefcase, activeCls: "bg-nm-primary text-white" },
  { key: "part_2", short: "The People", to: "/app/part/part_2", icon: Users, activeCls: "bg-nm-plum text-white" },
  { key: "moments", short: "The Moments", to: "/app/moments", icon: Map, activeCls: "bg-[#C2952B] text-white" },
];

export function SystemStrip({ current, plum }) {
  return (
    <div
      data-testid="system-strip"
      className={`mb-8 rounded-2xl border px-5 py-3 ${plum ? "border-nm-plum/15 bg-nm-plum/[0.04]" : "border-nm-primary/12 bg-nm-primary/[0.04]"}`}
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-nm-neutral">
          3 toolkits · 1 Manager Operating System
        </span>
        <div className="flex items-center gap-1 sm:ml-auto">
          {TOOLKITS.map((t, i) => {
            const active = t.key === current;
            const Icon = t.icon;
            const inner = (
              <span
                className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-medium transition-colors duration-200 ${
                  active ? t.activeCls : "text-nm-neutral hover:text-nm-ink"
                }`}
              >
                <Icon size={13} /> {t.short}
              </span>
            );
            let el;
            if (active) el = inner;
            else if (t.key === "moments")
              el = <a href={SCENARIO_GUIDE_URL} target="_blank" rel="noopener noreferrer" data-testid="system-strip-moments">{inner}</a>;
            else el = <Link to={t.to} data-testid={`system-strip-${t.key}`}>{inner}</Link>;
            return (
              <React.Fragment key={t.key}>
                {i > 0 && <span className="text-nm-neutral/40 text-xs">·</span>}
                {el}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}
